import axios from "axios";

const instance = axios.create({
  baseURL: process.env.REACT_APP_PD_API_URL || ""
});

// Where you would set stuff like your 'Authorization' header, etc ...
// instance.defaults.headers.common["Authorization"] = "AUTH TOKEN FROM INSTANCE";

instance.interceptors.request.use(
  request => {
    // Edit request config

    return request;
  },
  error => {
    console.log(error);
    return Promise.reject(error);
  }
);
instance.interceptors.response.use(
  response => {
    // Edit response config
    return response;
  },
  error => {
    console.log(error);

    return Promise.reject(error);
  }
);

export default instance;
